module.exports = __webpack_public_path__ + "img/p34.958d5f95.svg";